module.exports = __webpack_public_path__ + "img/api-recharge.1b6e834d.png";